/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FlagType = {
    Info: 'Info',
    Warning: 'Warning'
} as const;
export type FlagType = typeof FlagType[keyof typeof FlagType];


export function FlagTypeFromJSON(json: any): FlagType {
    return FlagTypeFromJSONTyped(json, false);
}

export function FlagTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagType {
    return json as FlagType;
}

export function FlagTypeToJSON(value?: FlagType | null): any {
    return value as any;
}

